<template>
    <div style2="width:900px;height:400px;">
        <h3 class="text-2xl mb-3">My Subscriptions</h3>

        <router-link :to="{name: 'home'}" class="text-blue-500">
            &laquo; Back
        </router-link>
    </div>
</template>

<script>
/**
 * @see https://medium.com/javascript-in-plain-english/many-ways-to-rerender-a-vue-component-660376d94cc1
 */
export default {
    data: () => ({}),

    created() {},

    mounted() {
        this.$nextTick(() => {
            if ('parentIFrame' in window) {
                parentIFrame.size(400, 900);
            }
        });
    },

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
